import { Stack, Text } from '@fluentui/react';
import React, { useContext } from 'react';
import { getThemeFromString } from '../../../../../Common/util/localStorageUtils';
import { ThemeContext } from '../../../../../HubLayout/models/ThemeContext';
import { ReleaseCloudStatusSearchResult } from '../../../../models/Release';
import { CompletionIndicatorIcon } from './CompletionIndicatorIcon';

interface ICloudStatusDisplayProps {
    cloudStatuses?: ReleaseCloudStatusSearchResult[];
    environments?: string;
}

export const CloudStatusDisplay: React.FC<ICloudStatusDisplayProps> = (
    props: ICloudStatusDisplayProps
) => {
    const themeContext = useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);

    if (!props.cloudStatuses?.length) {
        return <span>{props.environments}</span>;
    }

    return (
        <Stack tokens={{ childrenGap: 4 }}>
            {props.cloudStatuses.map((cloudStatus) => (
                <Stack
                    horizontal
                    verticalAlign="center"
                    tokens={{ childrenGap: 6 }}
                    key={cloudStatus.environment}
                >
                    <CompletionIndicatorIcon
                        completionIndicator={
                            cloudStatus.completionIndicator || 'NotStarted'
                        }
                        completionIndicatorString={
                            cloudStatus.completionIndicatorString
                        }
                        theme={theme}
                    />
                    <Text variant="medium">{cloudStatus.environment}</Text>
                </Stack>
            ))}
        </Stack>
    );
};
